// extracted by mini-css-extract-plugin
module.exports = {"clausesCounterOverLimit":"_9Cj4CUI0","clausesCounterErrorState":"_2qWNY40I"};